import { USE_FEDERATION } from './federation/config';
import * as federation from './federation/trips';
import * as legacy from './legacy/trips';
export const LIST_TRIPS = USE_FEDERATION
    ? federation.LIST_TRIPS
    : legacy.LIST_TRIPS;
export const LIST_PLANNED_TRIPS = USE_FEDERATION
    ? federation.LIST_PLANNED_TRIPS
    : legacy.LIST_PLANNED_TRIPS;
export const LIST_PLANNED_TRIPS_FOR_HOME = USE_FEDERATION
    ? federation.LIST_PLANNED_TRIPS_FOR_HOME
    : legacy.LIST_PLANNED_TRIPS_FOR_HOME;
export const ACCEPT_PLANNED_TRIP = USE_FEDERATION
    ? federation.ACCEPT_PLANNED_TRIP
    : legacy.ACCEPT_PLANNED_TRIP;
export const START_PLANNED_TRIP = USE_FEDERATION
    ? federation.START_PLANNED_TRIP
    : legacy.START_PLANNED_TRIP;
export const REJECT_PLANNED_TRIP = USE_FEDERATION
    ? federation.REJECT_PLANNED_TRIP
    : legacy.REJECT_PLANNED_TRIP;
